import PropTypes from 'prop-types';

const formPropType = PropTypes.shape({
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  status: PropTypes.object,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
});

export default formPropType;



// WEBPACK FOOTER //
// ./src/components/common/types/formPropsType.js